























































































































import Vue, { PropType } from "vue";
import StepLicense from "@/components/organisms/wizard/StepLicense.vue";
import StepUpdates from "@/components/organisms/wizard/StepUpdates.vue";
import StepLanguages from "@/components/organisms/wizard/StepLanguages.vue";
import StepAppearance from "@/components/organisms/wizard/StepAppearance.vue";
import StepComplete from "@/components/organisms/wizard/StepComplete.vue";
import StepMeeting from "./StepMeeting.vue";
import { DeviceConfiguration } from "@/models/deviceConfiguration";
import { ExternalProvider } from "@/models/providerAccount";
import { LicenseDetail } from "@/models/license";
import { WizardConfiguration } from "@/models/wizardConfiguration";
import wizardService from "@/services/wizardService";
import logger from "@/services/loggerService";
import StepCredentials from "@/components/organisms/wizard/StepCredentials.vue";
import StepDisplay from "./StepDisplay.vue";
import StepCalendar from "./StepCalendar.vue";

export default Vue.extend({
  name: "RoomWizard",
  data() {
    return {
      step: 1,
      loading: false,
      // deviceConfiguration: undefined as DeviceConfiguration | undefined,
      license: undefined as LicenseDetail | undefined,
      wizardConfiguration: {} as WizardConfiguration,
    };
  },
  props: {
    steps: {
      type: Array as PropType<string[]>,
      required: false,
      default: [],
    },
    update: {
      type: Boolean,
      required: false,
      default: false,
    },
    showBackToRooms: {
      type: Boolean,
      required: false,
      default: true,
    },
    // android: {
    //   type: Boolean,
    //   required: false,
    //   default: false,
    // },
    deviceConfiguration: {
      type: Object as PropType<DeviceConfiguration>,
    },
    calendarProviders: {
      type: Array as PropType<ExternalProvider[]>,
      default: () => [],
    },
    meetingProviders: {
      type: Array as PropType<ExternalProvider[]>,
      default: () => [],
    },
  },
  components: {
    StepCredentials,
    StepComplete,
    StepAppearance,
    StepLanguages,
    StepUpdates,
    StepLicense,
    StepDisplay,
    StepCalendar,
    StepMeeting,
  },
  computed: {},
  methods: {
    associateLicense(lic: LicenseDetail) {
      this.license = lic;
      if (this.deviceConfiguration) {
        this.deviceConfiguration.isEssential = lic.isEssential;
        this.deviceConfiguration.licenseKey = lic.key;
        this.deviceConfiguration.licensePackageId = lic.licensePackageId;
        this.$emit("configUpdated", this.deviceConfiguration);
      }
      this.wizardConfiguration.serial = lic.key;
    },
    async nexStep() {
      if (this.step == this.steps.length - 1) {
        this.saveConfig();
      }
      this.loading = false;
      this.step = this.step + 1;
    },
    prevStep() {
      this.step = this.step - 1;
    },
    restart() {
      this.step = 1;
    },
    async saveConfig() {
      if (this.deviceConfiguration && this.wizardConfiguration) {
        try {
          this.loading = true;
          await wizardService.sendConfig(
            this.deviceConfiguration,
            this.wizardConfiguration
          );
        } catch (e) {
          logger.error(e);
          this.$store.commit(
            "notifications/displayNotification",
            {
              message: e,
              type: "error",
            },
            { root: true }
          );
        } finally {
          this.loading = false;
        }
      }
    },
  },
});
